'use client';

import { CardContent, CardDescription, CardHeader, CardTitle } from "@repo/ui";
import { Zap, Shield, Users, BarChart3, Workflow, Clock } from "lucide-react";
import { LayeredCard } from "@/components/ui/BackgroundLayers";
import { useTranslation } from '@/lib/i18n/use-translation';

const FEATURE_KEYS = ['speed', 'security', 'collaboration', 'analytics', 'workflows', 'support'] as const;

const FEATURE_ICONS = {
  speed: Zap,
  security: Shield,
  collaboration: Users,
  analytics: BarChart3,
  workflows: Workflow,
  support: Clock,
} as const;

const Features = () => {
  const { t } = useTranslation();

  return (
    <section className="py-24 bg-layered-subtle">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center mb-16">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-foreground">
            {t('marketingLanding.features.title')}
          </h2>
          <p className="mt-6 text-lg leading-8 text-muted-foreground">
            {t('marketingLanding.features.subtitle')}
          </p>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <div className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-3">
            {FEATURE_KEYS.map((key) => {
              const Icon = FEATURE_ICONS[key];
              return (
                <LayeredCard key={key} variant="elevated">
                  <CardHeader>
                    <div className="flex items-center gap-4">
                      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-brand-yellow-100 dark:bg-brand-yellow-900/30 border border-brand-yellow-200/50">
                        <Icon className="h-6 w-6 text-brand-yellow-600 dark:text-brand-yellow-400" />
                      </div>
                      <CardTitle className="text-xl">
                        {t(`marketingLanding.features.items.${key}.title`)}
                      </CardTitle>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base">
                      {t(`marketingLanding.features.items.${key}.description`)}
                    </CardDescription>
                  </CardContent>
                </LayeredCard>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
